import { MAX_HEIGHT_MEDIA_CALC_DESKTOP, MAX_HEIGHT_MEDIA_CALC_MOBILE } from 'common/globalConstants'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { CSSProperties, PropsWithChildren, useMemo } from 'react'
import ReactPlayer from 'react-player'

export interface IPostCardVideoProps {
  url: string
  id: string
  onPlay: () => void
}

const useStyling = (isDevice: boolean, ...props) => {
  return useMemo(() => ({
    alignItems: 'center',
    maxHeight: isDevice ? MAX_HEIGHT_MEDIA_CALC_MOBILE : MAX_HEIGHT_MEDIA_CALC_DESKTOP,
    width: '100%',
  }) as CSSProperties, [isDevice, ...props])
}

export const PostCardVideo = ({ url, id, onPlay }: PropsWithChildren<IPostCardVideoProps>) => {
  const { isDevice } = useScreenSizes()

  const styles = useStyling(isDevice, url, id, onPlay)

  return (
    <>
      <ReactPlayer
        width="100%"
        style={styles}
        controls
        url={url}
        id={id}
        onPlay={onPlay}
      />
    </>
  )
}
